module.exports = __webpack_public_path__ + "img/broken-table-in-frame.b584940.svg";